import cx from 'classnames'
import Styles from '../PropertyForm.module.scss'

const Link = () => {
  return (
    <div className={cx(Styles.sectionSubheader, Styles.defaultInputWrapper)}>A property that contains a valid URL.</div>
  )
}

export default Link
